import { getStageFolderListFromZip } from "../convert/zipConvert";

import attachDB from "../db/attachDB";
import gumDB from "../db/gumDB";
import gumMatrixDB from "../db/gumMatrixDB";
import ponticDB from "../db/ponticDB";
import stageDB from "../db/stageDB";
import toothDB from "../db/toothDB";
import toothMatrixDB from "../db/toothMatrixDB";
import toothNumberDB from "../db/toothNumberDB";
import toothPartsDB from "../db/toothPartsDB";
import toothStageRawDB from "../db/toothStageRawDB";

import { getAttachDOFromFilePath } from "../matcher-tools/attachMatcher";
import { getGumDOFromFilePath } from "../matcher-tools/gumMatcher";
import { getGumMatrixDOFromFilePath } from "../matcher-tools/gumMatrixMatcher";
import { getPonticDOFromFilePath } from "../matcher-tools/ponticMatcher";
import { getToothDOFromFilePath } from "../matcher-tools/toothMatcher";
import { getToothMatrixDOFromFilePath } from "../matcher-tools/toothMatrixMatcher";
import { getToothNumberDOFromFilePath } from "../matcher-tools/toothNumberMatcher";
import { getToothPartsDOFromFilePath } from "../matcher-tools/toothPartsMatcher";
import { getToothStageRawDOFromFilePath } from "../matcher-tools/toothStageRawMatcher";
import gumModel from "../model/gumModel";
import iprModel from "../model/iprModel";
import ponticModel from "../model/ponticModel";

import { convertFileResourceFromZip } from "../convert/fileResourceConver";
import fileResource from "../resource/fileResource";

import toothModel from "../model/toothModel";
import toothPartsModel from "../model/toothPartsModel";

/**
 * @param {fileData} fileData
 */
const init = async (zip) => {
  loadFileResourceFromZip(zip);

  const stageDOList = await getStageFolderListFromZip(zip);
  stageDB.setStageDOList(stageDOList);

  const fileResourceList = fileResource.getFileResourceList();

  for (let fileResource of fileResourceList) {
    const { path: key, file: value } = fileResource;

    const toothDO = await getToothDOFromFilePath(key, value);
    if (toothDO) {
      toothDB.addToothDO(toothDO);
    }

    const toothPartsDO = await getToothPartsDOFromFilePath(key, value);
    if (toothPartsDO) {
      toothPartsDB.addToothPartsDO(toothPartsDO);
    }

    const toothStageRawDO = await getToothStageRawDOFromFilePath(key, value);
    if (toothStageRawDO) {
      toothStageRawDB.addToothStageRawDO(toothStageRawDO);
    }

    const toothNumberDO = await getToothNumberDOFromFilePath(key, value);
    if (toothNumberDO) {
      toothNumberDB.addToothNumberDO(toothNumberDO);
    }

    const toothMatrixDO = await getToothMatrixDOFromFilePath(key, value);
    if (toothMatrixDO) {
      toothMatrixDB.addToothMatrixDO(toothMatrixDO);
    }

    const gumDO = await getGumDOFromFilePath(key, value);
    if (gumDO) {
      gumDB.addGumDO(gumDO);
    }

    const gumMatrixDO = await getGumMatrixDOFromFilePath(key, value);
    if (gumMatrixDO) {
      gumMatrixDB.addGumMatrixDO(gumMatrixDO);
    }

    const ponticDO = await getPonticDOFromFilePath(key, value);
    if (ponticDO) {
      ponticDB.addPonticDO(ponticDO);
    }
  }
};

const loadFileResourceFromZip = (zip) => {
  const convertedFileResourceList = convertFileResourceFromZip(zip);
  for (let convertedFileResource of convertedFileResourceList) {
    fileResource.addFileResource(convertedFileResource);
  }
};

const loadModel = async () => {
  await toothModel.loadToothModelList();
  await toothPartsModel.loadToothPartsModelList();
  await gumModel.loadGumModelList();
  await ponticModel.loadPonticModelList();
  await iprModel.loadIPRModelList();
};

const loadModelByFirstStageNumber = async (stageNumber) => {
  const loadPromiseList = [
    toothModel.loadToothModelList(),
    toothPartsModel.loadToothPartsModelList(),
    ponticModel.loadPonticModelList(),
    iprModel.loadIPRModelList(),
    gumModel.loadGumModelListByStageNumber(stageNumber),
  ];
  await Promise.all(loadPromiseList);
};

const lazyLoadModel = async ({ onStageLoaded }) => {
  const stageDOList = stageDB.getStageDOList();
  for (let i = stageDOList.length - 1; i >= 0; i--) {
    const stageDO = stageDOList[i];
    const { stageNumber } = stageDO;
    await gumModel.loadGumModelListByStageNumber(stageNumber);
    onStageLoaded && onStageLoaded(stageDO);
  }
};

export default {
  init,
  loadModel,
  loadModelByFirstStageNumber,
  lazyLoadModel,
};
